import React, { Profiler } from "react";
import { useBlockAction } from "../src/liveblocks/useBlockAction";
import { RenderEvent, BenchmarkControl as IBenchmarkControl } from "./types";

export class BenchmarkControl implements IBenchmarkControl {
  startAt?: number | null;
  stopAt?: number | null;
  events: RenderEvent[];
  _clean: (() => void) | null;

  constructor() {
    this.startAt = null;
    this.stopAt = null;
    this.events = [];
    this._clean = null;
  }

  start() {
    this.startAt = Date.now();
    this.stopAt = null;
  }

  stop() {
    this.stopAt = Date.now();
    return this.events;
  }

  get on() {
    return this.startAt && !this.stopAt;
  }

  log(event: RenderEvent) {
    if (this.on) {
      this.events.push(event);
      console.log(event);
    }
  }

  cleanAllBlocks() {
    if (!this._clean) {
      throw new Error("_clean() method not initiated");
    }

    return this._clean();
  }
}

declare global {
  interface Window {
    sproutBenchmark: BenchmarkControl;
  }
}

export function BenchmarkProfiler({ children }: { children: React.ReactNode }) {
  const { cleanAllBlocks } = useBlockAction();
  if (!window.sproutBenchmark) {
    window.sproutBenchmark = new BenchmarkControl();
  }

  window.sproutBenchmark._clean = cleanAllBlocks;

  function onRender(
    id: string,
    phase: "mount" | "update",
    actualDuration: number,
    baseDuration: number,
    startTime: number,
    commitTime: number
  ) {
    window.sproutBenchmark.log({
      id,
      phase,
      actualDuration,
      baseDuration,
      startTime,
      commitTime,
    });
  }

  return (
    <Profiler id="space" onRender={onRender}>
      {children}
    </Profiler>
  );
}
